import { SearchOutlined, Close } from '@mui/icons-material';
import {
  Slide,
  Input,
  InputAdornment,
  Tooltip,
  IconButton,
} from '@mui/material';
import { tss } from 'tss-react/mui';

interface Props {
  searchText: string;
  setSearchText: (searchText: string) => void;
  hideSearch: () => void;
}

const useStyles = tss.create(({ theme }) => ({
  root: {
    minHeight: theme.spacing(8),
    display: 'flex',
    alignItems: 'center',
  },
}));

export const FileManagerSearchBar = ({
  searchText,
  setSearchText,
  hideSearch,
}: Props) => {
  const { classes } = useStyles();
  const handleKeyUp = (event: React.KeyboardEvent) => {
    if (event.key === 'Escape') {
      hideSearch();
    }
  };

  return (
    <div className={classes.root}>
      <Slide direction="up" in>
        <Input
          fullWidth
          type="search"
          placeholder="Type here to search file names..."
          disableUnderline
          autoFocus
          value={searchText}
          onChange={(event) => setSearchText(event.target.value)}
          onKeyUp={handleKeyUp}
          startAdornment={
            <InputAdornment position="start">
              <SearchOutlined />
            </InputAdornment>
          }
        />
      </Slide>
      <div>
        <Tooltip title="Cancel">
          <IconButton onClick={hideSearch} size="large">
            <Close />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
};
